module.exports = __webpack_public_path__ + "img/crema vaginal.9c0d3a02.png";